import React from 'react';
import { connect } from 'react-redux';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';
import queryString from 'query-string';
import BoxWrapper from 'components/atoms/BoxWrapper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import CustomTypography from 'components/atoms/CustomTypography';
import Button from 'components/atoms/Button/Button';
import { unsubscribeDailyPoll as unsubscribeDailyPollAction } from 'actions/polls';
import LoadingScreen from 'components/molecules/LoadingScreen';
import { colors } from 'theme/Variables';

const Unsubscribe = ({ location, unsubscribeDailyPoll, polls }) => {
    const { key } = queryString.parse(location.search);
    const {
        isUnsubscribeDailyPollSuccess,
        isUnsubscribeDailyPollRequest,
        isUnsubscribeDailyPollFailure,
    } = polls;

    return (
        <>
            <HeaderTemplate title="Unsubscribe" />
            {isUnsubscribeDailyPollRequest && <LoadingScreen />}
            <Container>
                <BoxWrapper mt="50">
                    <Grid container justify="center">
                        <Grid item xs={12} md={4}>
                            {!isUnsubscribeDailyPollSuccess && (
                                <>
                                    <CustomTypography
                                        align="center"
                                        variant="h2"
                                        fontSize="2.2"
                                        customfont
                                    >
                                        Are you sure you want to unsubscribe?
                                    </CustomTypography>
                                    <BoxWrapper mt="30">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => unsubscribeDailyPoll(key)}
                                        >
                                            Unsubscribe
                                        </Button>
                                    </BoxWrapper>
                                </>
                            )}
                            {isUnsubscribeDailyPollSuccess && (
                                <CustomTypography
                                    align="center"
                                    variant="h2"
                                    fontSize="2.2"
                                    customfont
                                >
                                    You will no longer receive daily polls messages.
                                </CustomTypography>
                            )}
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </Container>
        </>
    );
};

const mapStateToProps = ({ polls }) => {
    return { polls };
};

const mapDispatchToProps = (dispatch) => ({
    unsubscribeDailyPoll: (key) => dispatch(unsubscribeDailyPollAction(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
